<div class="list-container">
  @if (content) {
    <div class="list">
      <div class="header">
        <div class="header-column" style="width:20px"></div>
        @for (header of content.header; track header) {
          <div class="header-column" [ngStyle]="{'width': header.width}">
            {{ header.title }}
          </div>
        }
      </div>
      <div class="body">
        @for (row of content.rows; track row; let i = $index) {
          <div class="body-row">
            <div class="body-column" style="width:20px">
              <div (click)="toggleDetails(i)">
                <span>
                  <i class="caret far fa-chevron-down" [ngClass]="{'open': row.isDetailsOpen}"></i>
                </span>
              </div>
            </div>
            @for (column of row.columns; track column) {
              <div
                class="body-column"
                [ngClass]="{'avstand-column': column.typ === types.distance}"
                [ngStyle]="{'width': column.width}">
                @if (column.typ === types.text) {
                  <div>
                    {{ column.content }}
                  </div>
                }
                @if (column.typ === types.list) {
                  <div>
                    <ul>
                      @for (value of column.content; track value) {
                        <li>{{ value }}</li>
                      }
                    </ul>
                  </div>
                }
                @if (column.typ === types.nameList) {
                  <div>
                    <ul>
                      @for (value of column.content; track value) {
                        <li>
                          {{ writeMottagningsplats(value) }}
                        </li>
                      }
                    </ul>
                  </div>
                }
                @if (column.typ === types.distance) {
                  <div>
                    @for (c of column.content; track c) {
                      <div>
                        <span
                          [ngClass]="{ 'transportavstand-modified': $safeNavigationMigration(c?.isModified), 'transportavstand-not-modified': !c?.isModified }">{{
                        $safeNavigationMigration(c?.krontVagvalKm) + $safeNavigationMigration(c?.extraKm) + $safeNavigationMigration(c?.tillagsavstandStorstaAvlagg) | raskKilometer: 0 }}</span>
                        <rask-icon-button
                          [disabled]="!canDestinera()"
                          (click)="editTransportavstand(c, row)" icon="fas fa-pencil-alt">
                        </rask-icon-button>
                      </div>
                    }
                  </div>
                }
              </div>
            }
            @if (row.isDetailsOpen) {
              <div class="detailContent">
                <div class="header header-details">
                  @for (dh of content.detailsHeader; track dh) {
                    <div
                      class="header-column"
                      [ngClass]="{'header-border-bottom': dh.hasBorder, 'header-padding-top': dh.title === ''}"
                      [ngStyle]="{'width': dh.width}">
                      {{ dh.title }}
                    </div>
                  }
                </div>
                <div class="body-details">
                  <div class="body-details-row">
                    <div class="body-details-column" style="width:210px"></div>
                    @if (row.detailsRow.columns[0].content.length === 0) {
                      <div class="body-details-column">
                        {{ 'TPL_AODETAILS_INGA_VALBARA_MOTAGNINGSPLATSER' | translate }}
                      </div>
                    }
                    @for (column of row.detailsRow.columns; track column; let i = $index) {
                      <div
                        class="body-details-column" [ngStyle]="{'width': column.width}">
                        @if (column.typ === types.list) {
                          <div class="body-details-column">
                            <ul>
                              @for (value of column.content; track value) {
                                <li>{{ value }}</li>
                              }
                            </ul>
                          </div>
                        }
                        @if (column.typ === types.nameList) {
                          <div>
                            <ul>
                              @for (value of column.content; track value) {
                                <li>
                                  <span
                                    [ngClass]="{ 'line-through' : !value.aktiv, 'disabled-text': !value.destinerbart}">
                                    {{ writeMottagningsplats(value) }}
                                  </span>
                                  @if (!value.aktiv) {
                                    <rask-info [infoIconSolid]="false"
                                      class="destineringsRadInfo">Raden skickas ej med virkesordern
                                    </rask-info>
                                  }
                                </li>
                              }
                            </ul>
                          </div>
                        }
                        @if (column.typ === types.distance) {
                          <div>
                            @for (c of column.content; track c) {
                              <div class="avstand-details-column">
                                <span
                                  [ngClass]="{ 'transportavstand-modified': $safeNavigationMigration(c?.isModified), 'transportavstand-not-modified': !c?.isModified }">{{
                                $safeNavigationMigration(c?.krontVagvalKm) | raskKilometer: 0 }}</span>
                                <rask-icon-button
                                  [disabled]="!c.isActive"
                                  (click)="editTransportavstand(c, row)" icon="fas fa-pencil-alt">
                                </rask-icon-button>
                              </div>
                            }
                          </div>
                        }
                      </div>
                    }
                  </div>
                </div>
              </div>
            }
            @if (!row.isDetailsOpen) {
              <div class="detailsClosed"></div>
            }
          </div>
        }
      </div>
    </div>
  }
</div>
